import { Box } from 'components/Box/Box';
import { LegacyTooltip } from 'components/LegacyTooltip/LegacyTooltip';

type Props = {
  tooltipText: string;
  name: string;
  qaIdPrefix?: string;
};

export function LabelWithTooltip({ name, qaIdPrefix, tooltipText }: Props) {
  return (
    <Box display="flex" alignItems="center">
      {name}
      <Box position="relative" zIndex={1} ml="4px">
        <LegacyTooltip qaId={`${qaIdPrefix}-tooltip`}>
          {tooltipText}
        </LegacyTooltip>
      </Box>
    </Box>
  );
}
